import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { StreApperInfo } from 'src/app/models/streapper-info.model';

@Component({
    selector: 'streapper-card',
    templateUrl: './streapper-card.component.html',
    styleUrls: ['./streapper-card.component.scss'],
    standalone: false
})
export class StreapperCardComponent {
  @Input() streapper: StreApperInfo;
  fav: boolean;

  constructor(
    private readonly router: Router,
    private domSanitizer: DomSanitizer
  ) {}

  getProfilePicture() {
    if (this.streapper.picture) {
      if (this.streapper.picture?.startsWith('http')) {
        return this.streapper.picture;
      }

      return this.domSanitizer.bypassSecurityTrustUrl(
        'data:image/*;base64,' + this.streapper.picture
      );
    }
  }

  navigateToProfile() {
    this.router.navigate(['/streappers/detail'], {
      queryParams: { id: this.streapper.id },
    });
  }
}
